module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-not-started.0ee35f7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-not-started.svg
// module id = 1855
// module chunks = 0